// extracted by mini-css-extract-plugin
export default {"labelsContainer":"BarcodeLabels_labelsContainer__Q23cO","row":"BarcodeLabels_row__002i7","sticker":"BarcodeLabels_sticker__A+W1Y","barcodeInner":"BarcodeLabels_barcodeInner__9n3mN"};